import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {Company} from '../../../model/proposal/company';
import {CompanyPage} from '../../../model/company-page';

export const MyCompanyActions = createActionGroup({
  source: 'MyCompany API',
  events: {
    load: props<{ companyName: string }>(),
    loaded: props<{ company: Company }>(),
    NotFound: emptyProps(),
    errorLoading: props<{ error: Error }>(),
  }

});
export const CompanyPageActions = createActionGroup({
  source: 'CompanyPage API',
  events: {
    Load: props<{ companyId: string }>(),
    loaded: props<{ companyPage: CompanyPage }>(),
    ErrorLoading: props<{ error: Error }>(),
    memberPosterView: props<{ memberPosterView: boolean}>()
  }
});
